
import { Injectable } from '@angular/core';
import { CommonService } from '../common-service/common.service';
import { map } from 'rxjs/operators';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { Observable } from 'rxjs';

@Injectable()
export class UserService {

  constructor(private commonService: CommonService) {
  }

  /**
  * Name: searchCustomer
  * purpose: To serach customer
  * @param {string} searchText - customer details
  * @param {string} type - customer search type
  * @return {Observable} response data.
  */
  searchCustomer(searchText: string, type: string, userId: string): Observable<any> {
    var listOfCustomers = this.commonService.getCustomers(searchText, type, userId).pipe(debounceTime(500), map((data: any) => {
      return (
        data.length != 0 ? data as any[] : [{ "Customer": "No Record Found" } as any]
      );
    }
    ));
    return listOfCustomers;
  }

  /**
  * Name: searchChassis
  * purpose: To search customer with vin no.
  * @param {string} searchText - customer details
  * @return {Observable} response data.
  */
  searchChassis(searchText: string): Observable<any> {
    var listOfCustomers = this.commonService.getChassis(searchText).pipe(debounceTime(500), map((data: any) => {
      return (
        data.length != 0 ? data as any[] : [{ "Customer": "No Record Found" } as any]
      );
    }
    ));
    return listOfCustomers;
  }

  /**
  * Name: searchContact
  * purpose: To search customer with number
  * @param {string} searchText - customer details
  * @return {Observable} response data.
  */
  searchContact(searchText: string): Observable<any> {
    var listOfCustomers = this.commonService.searchContact(searchText).pipe(debounceTime(500), map((data: any) => {
      return (
        data.length != 0 ? data as any[] : [{ "Customer": "No Record Found" } as any]
      );
    }
    ));
    return listOfCustomers;
  }

  /**
  * Name: getFleetDetail
  * purpose: To get customer fleet details
  * @param {string} customerCode - customer code
  * @return {Observable} response data.
  */
  getFleetDetail(customerCode: string): Observable<any> {
    var listOfCustomers = this.commonService.searchFleet(customerCode).pipe(debounceTime(500), map((data: any) => {
      return (
        data.length != 0 ? data as any[] : [{ "Customer": "No Record Found" } as any]
      );
    }
    ));
    return listOfCustomers;
  }

  /**
  * Name: getServiceDetail
  * purpose: To get vehicle service info
  * @param {string} customerCode - customer code
  * @param {string} creId - cre code
  * @return {Observable} response data.
  */
  getServiceDetail(customerCode: string, creId: string, vin: string): Observable<any> {
    var listOfCustomers = this.commonService.searchVin(customerCode, creId, vin).pipe(debounceTime(500), map((data: any) => {
      return (
        data.length != 0 ? data as any[] : [{ "Customer": "No Record Found" } as any]
      );
    }
    ));
    return listOfCustomers;
  }

  /**
  * Name: getDoorstepServiceDetail
  * purpose: To get vehicle service info
  * @param {string} customerCode - customer code
  * @param {string} creId - cre code
  * @return {Observable} response data.
  */
  getDoorstepServiceDetail(customerCode: string, creId: string, vin: string): Observable<any> {
    var listOfCustomers = this.commonService.getDoorstepCustomerVinDetails(customerCode, creId, vin).pipe(debounceTime(500), map((data: any) => {
      return (
        data.length != 0 ? data as any[] : [{ "Customer": "No Record Found" } as any]
      );
    }
    ));
    return listOfCustomers;
  }

}
